<template>
    <div class="board__search">

        <div class="select" v-if="searchArr">
            <a href="javascript:;" class="select--btn" :class="{ active: select01 }"  @click.prevent="activeselect01">{{ selectedCategory.title }}</a>
            <slide-up-down :active="select01" class="select-option">
                <a href="javascript:;" class="select-option--btn" @click="setCategory(item)" v-for="(item, index) in searchArr" :key="index">{{ item.title }}</a>
            </slide-up-down>
        </div>
        <div class="board__search__box">
            <input type="text" placeholder="Хайлтын үгийг оруулна уу" v-model="searchKeyword" @keyup.enter="search()">
            <button @click="search()"></button>
        </div>
    </div>
</template>
<script>
    import SlideUpDown from 'vue-slide-up-down'

    export default {

        components: {
            SlideUpDown,
        },
        props: {
            searchArr: {
                type: Array,
                required: false,
            },
            boardId: {
                type: String,
                required: false,
            },
        },
        data() {
            return {
                searchKeyword: this.keyword,
                inSearchKeyword: '',
                prevData: '',
                selectOn: false,
                inSearch: false,
                select01: false,
                selectedCategory: { title: '전체', value: '' }
            }
        },
        methods: {
            search() {
                // const s = this.$refs.selVal ? this.$refs.selVal.value : ''
                const s = 'title'
                this.$emit("setState", s, this.searchKeyword, this.selectedCategory.value);
                this.prevData = s
            },
            selectFn() {
                this.selectOn = !this.selectOn;
            },
            outsideClick(event) {
                if (!event.target.closest('.board__select')) {
                    this.selectOn = false;
                }
            },
            activeselect01() {
                this.select01 = !this.select01;
            },
            setCategory(value) {
                this.selectedCategory = value
                this.activeselect01()
            }
        },
        mounted() {
            console.log(this.searchArr)
            if(this.searchArr){
                if(this.searchArr.length > 0){
                    this.selectedCategory = this.searchArr[0]
                }
            }

            document.addEventListener('click', this.outsideClick);
        },
        watch: {
            boardId(){
                this.searchKeyword = ''
            }
        },
    }
</script>